import React, { Component } from 'react';
import { connect } from 'react-redux';
import PhaseHistoryCard from 'components/PhaseHistoryCard';
import PhaseType from 'types/phase';
import HistoryFilters from '../../components/historyFilters';
import S from '../../components/phaseHistory.scss';

class PhaseHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSortByDateTime: true,
      showSpotBot: true,
      onlyComms: false,
    };
    this.toggleSortByDateTime = this.toggleSortByDateTime.bind(this);
    this.toggleEventFilters = this.toggleEventFilters.bind(this);
  }

  toggleSortByDateTime = () => this.setState({
    isSortByDateTime: !this.state.isSortByDateTime,
  });

  toggleEventFilters = filters => this.setState(filters, () => this.filterEventsList());

  filterEventsList = () => {
    const { onlyComms, showSpotBot } = this.state;
    const { events } = this.props.phase;
    let filteredEvents = [];
    if (onlyComms && showSpotBot) {
      filteredEvents = events.filter(event => event.kind.includes('communication'));
    } else if (!onlyComms && !showSpotBot) {
      filteredEvents = events.filter(event => event.user !== 'SPOTBOT');
    } else {
      filteredEvents = events;
    }
    filteredEvents = filteredEvents.filter(event => event.kind !== 'api');
    return filteredEvents;
  }

  groupEvents = () => {
    const scopedEvents = {};
    const events = this.filterEventsList();
    if (this.state.isSortByDateTime) {
      scopedEvents['All Statuses'] = events;
      return scopedEvents;
    }
    events.forEach((event) => {
      const scopeName = event.status;
      if (!scopedEvents[scopeName]) scopedEvents[scopeName] = [];
      scopedEvents[scopeName].push(event);
    });
    return scopedEvents;
  }

  renderHistoryList = () => {
    const scopedEvents = this.groupEvents();
    return Object.keys(scopedEvents).map((name, i) => <div key={name}>
      <PhaseHistoryCard
        name={name}
        events={scopedEvents[name]}
        collapsed={i > 0}
        isSortByDateTime={this.state.isSortByDateTime}
        phase={this.props.phase}
        isPhaseHistoryTab
      />
    </div>);
  }

  render = () => (<section className={S.phaseHistoryContainer}>
    <HistoryFilters
      toggleSortByDateTime={this.toggleSortByDateTime}
      toggleEventFilters={this.toggleEventFilters}
    />
    {this.renderHistoryList()}
  </section>);
}

PhaseHistory.defaultProps = { phase: {} };

PhaseHistory.propTypes = { phase: PhaseType.isRequired };

const mapStateToProps = state => ({ phase: state.phase.details });

export default connect(mapStateToProps)(PhaseHistory);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseHistory/index.jsx